import React, { useState } from "react";
import { FaEnvelope, FaClock, FaLock } from "react-icons/fa";
import Swal from "sweetalert2";

const WEB3FORMS_URL = "https://api.web3forms.com/submit";

async function submitViaWeb3Forms(payload, accessKey) {
  const name = String(payload.name || "").trim();
  const email = String(payload.email || "").trim();
  const company = String(payload.company || "").trim();
  const message = String(payload.message || "").trim();

  const res = await fetch(WEB3FORMS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      access_key: accessKey,
      subject: `TechTalent — mesazh nga ${name}`,
      from_name: name,
      name,
      email,
      message: `Kompania: ${company || "-"}\n\n${message}`,
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!data.success) {
    throw new Error(
      data.message || data.error || "Dështoi dërgimi (Web3Forms)",
    );
  }
}

function Contact() {
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === "sending") return;

    const form = e.target;
    const formData = new FormData(form);

    const payload = {
      name: formData.get("name"),
      email: formData.get("email"),
      company: formData.get("company"),
      message: formData.get("message"),
    };

    const web3Key = (
      process.env.REACT_APP_WEB3FORMS_ACCESS_KEY ||
      "4e799dc2-86b7-4bf4-8717-c8eac982ef5c"
    ).trim();

    try {
      setStatus("sending");
      await submitViaWeb3Forms(payload, web3Key);

      form.reset();
      await Swal.fire({
        icon: "success",
        title: "Mesazhi u dërgua",
        text: "Faleminderit! Do t’ju kontaktojmë së shpejti.",
        confirmButtonText: "Në rregull",
      });
    } catch (err) {
      console.error(err);
      await Swal.fire({
        icon: "error",
        title: "Dërgimi dështoi",
        text: "Provoni përsëri ose na shkruani në kontakt@techtalent-ks.com.",
        confirmButtonText: "Mbyll",
      });
    }
    setStatus("idle");
  };

  return (
    <section className="contact section-pad" id="contact">
      <div className="container">
        <div className="contact-shell">
          <aside
            className="contact-aside"
            aria-labelledby="contact-aside-heading"
          >
            <p className="contact-aside-label">Filloni një bisedë</p>
            <h2 id="contact-aside-heading" className="contact-aside-title">
              Na tregoni çfarë doni të ndërtoni
            </h2>
            <p className="contact-aside-lead">
              Tregoni çfarë keni në mendje — afatin, buxhetin dhe çfarë doni të arrini. Ju përgjigjemi brenda 24 orësh me hapat e ardhshëm.
            </p>
            <ul className="contact-aside-list">
              <li>
                <span className="contact-aside-icon" aria-hidden="true">
                  <FaClock />
                </span>
                <span>Përgjigje e parë zakonisht brenda një dite pune</span>
              </li>
              <li>
                <span className="contact-aside-icon" aria-hidden="true">
                  <FaLock />
                </span>
                <span>
                  NDA e disponueshme para çdo zbulimi teknik
                </span>
              </li>
              <li>
                <span className="contact-aside-icon" aria-hidden="true">
                  <FaEnvelope />
                </span>
                <span>
                  Preferoni email?{" "}
                  <a
                    className="contact-mail"
                    href="mailto:kontakt@techtalent-ks.com"
                  >
                    kontakt@techtalent-ks.com
                  </a>
                </span>
              </li>
            </ul>
          </aside>

          <div className="contact-panel">
            <div className="contact-panel-head">
              <span className="section-tag section-tag--dark">Përshkrimi</span>
              <p className="contact-panel-hint">
                Fushat me <span className="contact-req">*</span> janë të
                detyrueshme.
              </p>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="field">
                  <label htmlFor="name">
                    Emri dhe Mbiemri <span className="contact-req">*</span>
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Emri dhe Mbiemri"
                    autoComplete="name"
                    required
                  />
                </div>
                <div className="field">
                  <label htmlFor="email">
                    Emaili juaj <span className="contact-req">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Emaili juaj"
                    autoComplete="email"
                    required
                  />
                </div>
              </div>

              <div className="field">
                <label htmlFor="company">Emri i Kompanisë</label>
                <input
                  id="company"
                  name="company"
                  type="text"
                  placeholder="Emri i Kompanisë"
                  autoComplete="organization"
                />
              </div>

              <div className="field">
                <label htmlFor="message">
                  Përshkrimi <span className="contact-req">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Përshkrimi"
                  required
                />
              </div>

              <button
                type="submit"
                className="contact-submit"
                disabled={status === "sending"}
              >
                {status === "sending" ? "Duke dërguar…" : "Dërgo"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
